import { dataUrlToBlob } from 'utils/error-log/data-url-to-blob';
import { isErrorLogScreenshot } from 'utils/error-log/is-error-log-screenshot';

const OBJECT_URL_REVOKE_MS = 60_000;

export function openScreenshotInNewTab(dataUrl: string): boolean {
  if (!isErrorLogScreenshot(dataUrl)) {
    return false;
  }

  const blob = dataUrlToBlob(dataUrl);
  if (!blob) {
    return false;
  }

  const objectUrl = URL.createObjectURL(blob);
  const opened = window.open(objectUrl, '_blank');
  if (!opened) {
    URL.revokeObjectURL(objectUrl);
    return false;
  }

  opened.opener = null;
  window.setTimeout(() => {
    URL.revokeObjectURL(objectUrl);
  }, OBJECT_URL_REVOKE_MS);
  return true;
}
